import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Card } from "react-bootstrap";
import { Button, Table, Modal } from "react-bootstrap";
import "../GoalTracker/NewGoalTrackerChart.css"
import {
  FaArrowTrendUp,
  FaMinus,
  FaPersonWalkingWithCane,
  FaPlus,
  FaFilter,
  FaCalendarDays,
  FaHeartPulse,
  FaWallet,
  FaHourglassHalf,
} from "react-icons/fa6";
import { useMemo } from "react";
import { calculateSIPDeficit } from "../../../utils/goalUtils";
import { formatRupees } from "../../../utils/inputsValidation";
import socket from "../../../context/socket";
import { runRetirementCalculation } from "../../../retirement-calc/dist/index.js";

import api from "../../../utils/api";

export default function GoalTrackerChart({
  goal,
  mappedFunds,
  chartData,
  isGetClientGoal,
  setIsLoading,
  selectedCard,
  roomId,
  dreamPoints,
  retirementResult,
  retirementInvestmentValue = 0, 
}) {
  console.log("goal88", retirementResult);
  const [numberOfLabels, setNumberOfLabels] = useState(10);
  const [projectedAchievement, setProjectedAchievement] = useState(0);
  const [projectedShortfall, setProjectedShortfall] = useState(0);
  const [sipDeficit, setSipDeficit] = useState(0);
  const [showRetirementTable, setshowRetirementTable] = useState(false)
  const [projectionView, setProjectionView] = useState("year");
  const [projectionSearch, setProjectionSearch] = useState("");
  const [selectedAge, setSelectedAge] = useState("All Ages");
  const [selectedStage, setSelectedStage] = useState("All Stages");
  const [selectedHighlight, setSelectedHighlight] =useState("All Highlights");
  const [showProjectionFilters, setShowProjectionFilters] = useState(false);
  const [retirementCorpus, setretirementCorpus] = useState(0)

  const [sipOverride, setSipOverride] = useState("");
  const [stepUpOverride, setStepUpOverride] = useState("");
  const [showSipInputs, setShowSipInputs] = useState(false);
  const [currentValueOverride, setCurrentValueOverride] = useState("");
const [isFetchingRetirementInvestments, setIsFetchingRetirementInvestments] =
  useState(false);
  const syncRetirementProjection = (updates) => {
  if (!roomId) return;

  socket.emit("retirement_projection_sync", {
    room: roomId,
    ...updates,
  });
};
const fetchRetirementInvestmentValues = async () => {
  setIsFetchingRetirementInvestments(true);

  try {
    const response = await api.get(`advisor/allFolio/${roomId}`);
    const investmentData = response?.data || {};

    let totalSIP = 0;
    let totalCurrentValue = 0;

    
    Object.values(investmentData).forEach((category) => {
      Object.values(category || {}).forEach((investments) => {
        if (!Array.isArray(investments)) return;

        investments.forEach((investment) => {
          if (
            String(investment.goal_name || "").trim().toLowerCase() !==
            "retirement planning"
          ) {
            return;
          }

          totalSIP += Number(investment.sip) || 0;
          totalCurrentValue += Number(investment.aum_as_per_rta) || 0;
        });
      });
    });
const nextSip = String(Math.round(totalSIP));
const nextCurrentValue = String(Math.round(totalCurrentValue));

    // Pass these values to the existing SIP popup component.

setSipOverride(nextSip);
setCurrentValueOverride(nextCurrentValue);
if (roomId) {
  socket.emit("retirement_projection_sync", {
    room: roomId,
    sipOverride: nextSip,
    currentValueOverride: nextCurrentValue,
  });
}
  } catch (error) {
    console.error("Failed to fetch retirement investments:", error);
  } finally {
    setIsFetchingRetirementInvestments(false);
  }
};


const handleOpenSipInputs = () => {
  setShowSipInputs(true);
};

  const xAxisCategories = useMemo(() => {
    const timelineInMonths = goal.timeline * 12;
    const startYear = Number(goal.startYear);
    const totalPoints = timelineInMonths + 12;

    // If total data points (months) are less than desired labels, show all years individually
    if (timelineInMonths < numberOfLabels * 12) {
      return Array.from({ length: timelineInMonths + 12 }, (_, i) =>
        i % 12 === 0 ? (startYear + Math.floor(i / 12)).toString() : ""
      );
    }


    // Else: show ~20 evenly spaced labels
    const interval = Math.floor(totalPoints / numberOfLabels);

    return Array.from({ length: totalPoints }, (_, i) =>
      i % interval === 0 ? (startYear + Math.floor(i / 12)).toString() : ""
    );
  }, [goal.timeline, goal.startYear, numberOfLabels]);

  // console.log('Monthly-Sip', chartData);

  // console.log("goal88", xAxisCategories, goal, chartData);

  const chartOptions = useMemo(
    () => ({
      chart: {
        type: "area",
        toolbar: { show: false },
        zoom: {
          enabled: false,
        },
        animations: {
          enabled: false,
        },
      },
      xaxis: {
        categories: xAxisCategories,
        labels: {
          style: {
            fontSize: "10px",
            color: document.body.classList.contains("dark-mode")
              ? "#fff"
              : "#000", //not working
            fill: document.body.classList.contains("dark-mode")
              ? "#fff"
              : "#000",
          },
        },
      },
      yaxis: {
        show: false, // Hide Y-axis values as requested
      },
      stroke: {
        curve: "smooth", // Smooth curve
        width: [3, 3], // Width for both lines
        dashArray: [0, 5], // Apply dashed line
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          const dataIndex = opts.dataPointIndex;
          const seriesIndex = opts.seriesIndex;
          const totalPoints = opts.w.globals.series[seriesIndex].length;
          // Only show label at last point
          if (dataIndex === totalPoints - 1) {
            return formatAmount(val);
          }
          return "";
        },
        offsetX: -10,
        offsetY: -10,
        style: {
          fontSize: "12px",
          fontWeight: "600",
          colors: ["#52B58C", "#666"], // Target: green, SIP: dark gray
        },
        background: {
          enabled: true,
          borderRadius: 4,
          padding: 4,
          foreColor: "#fff",
          color: function ({ seriesIndex }) {
            return seriesIndex === 0 ? "#666" : "#52B58C";
          },
        },
      },
      // dataLabels: { enabled: false },
      fill: {
        type: ["gradient", "gradient"], // Solid fill for SIP Growth, gradient for Target
        // gradient: {
        //   shadeIntensity: 0.4,
        //   opacityFrom: 0.7,
        //   opacityTo: 0.2,
        // },
      },
      grid: { show: false },
      tooltip: {
        enabled: true,
        shared: true,
        intersect: false,
        x: {
          formatter: (value, { dataPointIndex }) =>
            `Month ${dataPointIndex + 1}`, // Keep tooltip showing month-wise
        },
        y: {
          formatter: (value) => `₹${value?.toLocaleString()}`,
        },
        theme: document.body.classList.contains("dark-mode") ? "dark" : "light",
        style: {
          fontSize: "12px",
          fontFamily: "Helvetica, Arial, sans-serif",
          color: document.body.classList.contains("dark-mode")
            ? "#fff"
            : "#000", // Tooltip text color
        },
      },
      legend: {
        position: "bottom",
        horizontalAlign: "center",
        labels: {
          colors: document.body.classList.contains("dark-mode")
            ? "#fff"
            : "#000", // Legend label color based on theme
        },
      },
    }),
    [xAxisCategories]
  );

  console.log('chartOptions', chartOptions, chartData?.series);

  const monthlyTargetGrowth = chartData?.monthlyTargetGrowth
    ? chartData.monthlyTargetGrowth
    : [];

  const monthlyMappedGrowth = chartData?.monthlyMappedGrowth
    ? chartData.monthlyMappedGrowth
    : [];

  /******Project shortfall and achievment */

  useEffect(() => {
    if (!monthlyMappedGrowth?.length || !monthlyTargetGrowth?.length) return;

    const endValueTargetGrowth =
      monthlyTargetGrowth[monthlyTargetGrowth.length - 1] || 0;
    const endValueMappedGrowth =
      monthlyMappedGrowth[monthlyMappedGrowth.length - 1] || 0;

    const achievement =
      endValueTargetGrowth > 0
        ? (endValueMappedGrowth / endValueTargetGrowth) * 100
        : 0;

    const shortfall = endValueTargetGrowth - endValueMappedGrowth;
    console.log("shortfall", endValueTargetGrowth, monthlyMappedGrowth);
    setProjectedAchievement(Number(achievement.toFixed(2)));
    setProjectedShortfall(Number(shortfall.toFixed(2)));

    // console.log("✅ Calculated Achievement & Shortfall:", {
    //   endValueMappedGrowth,
    //   endValueTargetGrowth,
    //   achievement,
    //   shortfall,
    // });
  }, [monthlyMappedGrowth, monthlyTargetGrowth]);

  /******Project shortfall and achievment */
  // Dream Point corpus 
  useEffect(() => {
    setretirementCorpus(
      dreamPoints?.client?.dreamPoints?.[0]?.action_data?.[0]?.retirementCorpus || 0
    )
  }, [dreamPoints])


  useEffect(() => {
    // Wait for a short delay to simulate chart re-render (adjust as needed)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000); // wait 300ms for smoother loading UX

    return () => clearTimeout(timer);
  }, [numberOfLabels]);

  // console.log("chartOptions", chartOptions.xaxis.categories);

  const formatAmount = (amount) => {
    if (!amount) return "0";

    const absAmount = Math.abs(amount); // Handle negative values properly

    if (absAmount >= 10000000) {
      return (amount / 10000000).toFixed(2) + " Cr"; // Convert to Crores
    } else if (absAmount >= 100000) {
      return (amount / 100000).toFixed(2) + " L"; // Convert to Lakhs
    } else if (absAmount >= 1000) {
      return (amount / 1000).toFixed(2) + " K"; // Convert to Thousands
    } else {
      return amount?.toLocaleString("en-IN"); // Default format with commas
    }
  };

  const formattedTarget = useMemo(
    () => formatAmount(isGetClientGoal?.TargetAmount),
    [isGetClientGoal]
  );
  const formattedAccumulated = useMemo(
    () => formatAmount(goal?.accumulatedAmount),
    [goal]
  );
  const formattedShortfall = useMemo(
    () => formatAmount(Math.abs(projectedShortfall)),
    [goal]
  );
  const formattedSipDeficit = useMemo(
    () => formatAmount(Math.abs(sipDeficit)),
    [sipDeficit]
  );
  const formattedRunninSip = useMemo(
    () => formatAmount(Math.abs(goal?.runningSIP)),
    [goal]
  );

  useEffect(() => {
    // console.log("123", goal);
    const deficit = calculateSIPDeficit(goal?.accumulatedAmount, goal);
    console.log("deficit", deficit);
    setSipDeficit(deficit);
  }, [goal]);
  // 
  const [selectedScenario, setSelectedScenario] = useState("base");

  const formatCompactRupees = (amount) => {
    if (amount === undefined || amount === null || isNaN(amount) || amount === 0) return "—";
    const abs = Math.abs(amount);
    const sign = amount < 0 ? "-" : "";
    if (abs >= 1e7) {
      const val = abs / 1e7;
      return `${sign}₹${val.toFixed(2)} Cr`;
    }
    if (abs >= 1e5) {
      const val = abs / 1e5;
      return `${sign}₹${val >= 10 ? val.toFixed(1) : val.toFixed(1)} L`;
    }
    return `${sign}₹${Math.round(abs).toLocaleString("en-IN")}`;
  };

  const isRetirement =
    selectedCard?.text === "Retirement Planning" ||
    selectedCard?._id === "66cd7582ec2e16f636c838be" ||
    selectedCard?.text?.toLowerCase()?.includes("retirement") ||
    goal?.goalName?.toLowerCase()?.includes("retirement") ||
    goal?._id === "66cd7582ec2e16f636c838be" ||
    isGetClientGoal?.recActionPlanR4?.toLowerCase()?.includes("expenses") ||
    isGetClientGoal?.recActionPlanR4?.toLowerCase()?.includes("retirement");

  useEffect(() => {
    if (retirementResult?.inputs) {
      if (retirementResult.inputs.currentMonthlySip != null) {
        setSipOverride(
          retirementResult.inputs.currentMonthlySip
            ? retirementResult.inputs.currentMonthlySip.toString()
            : ""
        );
      }
      if (retirementResult.inputs.annualSipStepUp != null) {
        const pct = retirementResult.inputs.annualSipStepUp * 100;
        setStepUpOverride(pct ? pct.toString() : "");
      }
    } else if (isGetClientGoal) {
      if (
        isGetClientGoal.scenarioMonthSaving != null ||
        isGetClientGoal.monthlysaving != null
      ) {
        const val =
          isGetClientGoal.scenarioMonthSaving ?? isGetClientGoal.monthlysaving;
        setSipOverride(val ? val.toString() : "");
      }
      if (isGetClientGoal.annualStepUp != null) {
        setStepUpOverride(
          isGetClientGoal.annualStepUp
            ? isGetClientGoal.annualStepUp.toString()
            : ""
        );
      }
    }
  }, [retirementResult, isGetClientGoal]);

  const activeRetirementResult = useMemo(() => {
    if (!retirementResult || !retirementResult.inputs) return retirementResult;
    const base = { ...retirementResult.inputs };


let hasInputsOverride = false;

// FIX: Apply Running SIP to the calculation inputs
if (
  sipOverride !== "" &&
  Number.isFinite(Number(sipOverride)) &&
  Number(sipOverride) >= 0
) {
  base.currentMonthlySip = Number(sipOverride);
  hasInputsOverride = true;
}

// Keep your existing Current Value logic
if (
  currentValueOverride !== "" &&
  Number.isFinite(Number(currentValueOverride)) &&
  Number(currentValueOverride) >= 0
) {
  base.existingRetirementInvestments = Number(currentValueOverride);
  hasInputsOverride = true;
}

    if (stepUpOverride !== "" && !isNaN(Number(stepUpOverride))) {
      let rawStepUp = Number(stepUpOverride);
      let decimal = rawStepUp;
      if (
        rawStepUp > 0.5 &&
        base.currentMonthlySip > 0 &&
        rawStepUp > 1 &&
        rawStepUp > base.currentMonthlySip
      ) {
        decimal = rawStepUp / base.currentMonthlySip;
      } else if (rawStepUp > 0.5) {
        decimal = rawStepUp / 100;
      }
      base.annualSipStepUp = Math.min(0.5, Math.max(0, decimal));
      hasInputsOverride = true;
    }

    if (selectedScenario === "base" && !hasInputsOverride) {
      return retirementResult;
    }

    let overrides = {};
    if (selectedScenario === "lower_return") {
      overrides = {
        accumulationReturn: Math.max(0, base.accumulationReturn - 0.02),
        withdrawalReturn: Math.max(0, base.withdrawalReturn - 0.01),
      };
    } else if (selectedScenario === "higher_return") {
      overrides = {
        accumulationReturn: base.accumulationReturn + 0.02,
        withdrawalReturn: base.withdrawalReturn + 0.01,
      };
    } else if (selectedScenario === "higher_inflation") {
      overrides = {
        preRetirementInflation: base.preRetirementInflation + 0.01,
        postRetirementInflation: base.postRetirementInflation + 0.01,
      };
    } else if (selectedScenario === "longer_life") {
      overrides = {
        planIncomeUntilAge: base.planIncomeUntilAge + 5,
      };
    } else if (selectedScenario === "combined_stress") {
      overrides = {
        accumulationReturn: Math.max(0, base.accumulationReturn - 0.02),
        withdrawalReturn: Math.max(0, base.withdrawalReturn - 0.01),
        preRetirementInflation: base.preRetirementInflation + 0.01,
        postRetirementInflation: base.postRetirementInflation + 0.01,
        planIncomeUntilAge: base.planIncomeUntilAge + 5,
      };
    }

    try {
      const scenarioInputs = { ...base, ...overrides };
      return runRetirementCalculation(scenarioInputs);
    } catch (e) {
      console.error("Error calculating scenario:", e);
      return retirementResult;
    }
  }, [
  retirementResult,
  selectedScenario,
  sipOverride,
  stepUpOverride,
  currentValueOverride,
]);

  const retirementProjectionRows = useMemo(() => {
  if (!activeRetirementResult) return [];

  const rows = [];

  // ACCUMULATION
  (activeRetirementResult.accumulation?.years || []).forEach((year) => {
    rows.push({
      age: Math.round(Number(year.ageAtEnd)),
      stage: "Accumulating",

      contribution: Number(year.contributionsThisYear) || 0,

      expense: 0,
      income: 0,
      portfolioDraw: 0,

      endingBalance: Number(year.endingBalance) || 0,
    });
  });

  // WITHDRAWAL
  (activeRetirementResult.withdrawal?.years || []).forEach((year) => {
    rows.push({
      age: Math.round(Number(year.ageAtEnd)),
      stage: "Withdrawing",

      contribution: 0,

      expense: Number(year.totalExpense) || 0,

      income: Number(year.totalIncome) || 0,

      portfolioDraw:
        Number(year.totalPortfolioWithdrawal) || 0,

      endingBalance:
        Number(year.endingBalance) || 0,
    });
  });

  return rows.sort((a, b) => a.age - b.age);
}, [activeRetirementResult]);

  const retirementMonthlyRows = useMemo(() => {
    if (!activeRetirementResult) return [];

    const accumMonths = activeRetirementResult?.accumulation?.months || [];
    const withMonths = activeRetirementResult?.withdrawal?.months || [];

    const rows = [];

    accumMonths.forEach((m) => {
      const exactAge = Number(m.age);
      const age = Math.floor(exactAge);
      const monthOfYear = Math.floor((exactAge - age) * 12 + 0.000001) + 1;

      rows.push({
        monthIndex: m.monthIndex,
        age: age,
        ageMonthLabel: `${age} - Month ${monthOfYear}`,
        stage: "Accumulating",
        contribution: m.contribution || 0,
        expense: 0,
        income: 0,
        endingBalance: m.endingBalance || 0,
      });
    });

    withMonths.forEach((m) => {
      const exactAge = Number(m.age);
      const age = Math.floor(exactAge);
      const monthOfYear = Math.floor((exactAge - age) * 12 + 0.000001) + 1;

      rows.push({
        monthIndex: m.monthIndex,
        age: age,
        ageMonthLabel: `${age} - Month ${monthOfYear}`,
        stage: "Withdrawing",
        contribution: 0,
        expense: m.lifestyleExpense || 0,
        income: m.dependableIncome || 0,
        endingBalance: m.endingBalance || 0,
      });
    });

    return rows;
  }, [activeRetirementResult]);

  const ageRangeOptions = useMemo(() => {
    if (!retirementProjectionRows || retirementProjectionRows.length === 0) return [];
    const ages = retirementProjectionRows.map((r) => r.age);
    const minAge = Math.min(...ages);
    const maxAge = Math.max(...ages);

    const options = [];
    let start = Math.floor(minAge / 10) * 10 + 1;
    if (minAge < start) start = minAge;

    while (start <= maxAge) {
      const end = Math.min(maxAge, start + 9);
      options.push({
        value: `${start}-${end}`,
        label: `Age ${start}–${end}`,
      });
      start = start + 10;
    }

    return options;
  }, [retirementProjectionRows]);

  const peakCorpusInfo = useMemo(() => {
    if (!retirementProjectionRows || retirementProjectionRows.length === 0) return null;
    let maxBal = -Infinity;
    let peakAge = null;
    retirementProjectionRows.forEach((r) => {
      if (r.endingBalance > maxBal) {
        maxBal = r.endingBalance;
        peakAge = r.age;
      }
    });
    return peakAge ? { age: peakAge, maxBal } : null;
  }, [retirementProjectionRows]);
  const corpusLastsUntil = useMemo(() => {
  if (!retirementProjectionRows?.length) return null;

  const depletedRow = retirementProjectionRows.find(
    (row) => Number(row.endingBalance) <= 0
  );

  return depletedRow?.age || null;
}, [retirementProjectionRows]);

  const filteredProjectionRows = useMemo(() => {
    const sourceRows =
      projectionView === "year"
        ? retirementProjectionRows
        : retirementMonthlyRows;

    const search = projectionSearch.trim().toLowerCase();

    return sourceRows.filter((row) => {
      // SEARCH
      const matchesSearch =
        !search ||
        String(row.age).toLowerCase().includes(search) ||
        String(row.ageMonthLabel || "").toLowerCase().includes(search) ||
        String(row.stage).toLowerCase().includes(search);

      // AGE (Support both 10-year age range like "51-60" and single age)
      const matchesAge =
        selectedAge === "All Ages" ||
        (() => {
          if (selectedAge.includes("-") || selectedAge.includes("–")) {
            const parts = selectedAge.replace("Age ", "").split(/–|-/);
            if (parts.length === 2) {
              const min = Number(parts[0]);
              const max = Number(parts[1]);
              return row.age >= min && row.age <= max;
            }
          }
          return String(row.age) === String(selectedAge);
        })();

      // STAGE
      const matchesStage =
        selectedStage === "All Stages" ||
        row.stage === selectedStage;

      // HIGHLIGHT
      let matchesHighlight = true;

      if (selectedHighlight.includes("Ruin") || selectedHighlight === "Shortfall") {
        matchesHighlight = Number(row.endingBalance) <= 0;
      } else if (selectedHighlight.includes("Peak")) {
        matchesHighlight = peakCorpusInfo ? row.age === peakCorpusInfo.age : true;
      } else if (selectedHighlight.includes("High Outflow")) {
        matchesHighlight = Number(row.expense) > 0;
      } else if (selectedHighlight === "Contributions") {
        matchesHighlight = Number(row.contribution) > 0;
      } else if (selectedHighlight === "Expenses") {
        matchesHighlight = Number(row.expense) > 0;
      } else if (selectedHighlight === "Income") {
        matchesHighlight = Number(row.income) > 0;
      }

      return (
        matchesSearch &&
        matchesAge &&
        matchesStage &&
        matchesHighlight
      );
    });
  }, [
    projectionView,
    retirementProjectionRows,
    retirementMonthlyRows,
    projectionSearch,
    selectedAge,
    selectedStage,
    selectedHighlight,
    peakCorpusInfo,
  ]);

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-5">
          <div className="row">
            <div className="col-12 my-2">
              <h3 className="txt-color">Goal Tracker</h3>
            </div>
            <div className="col-6">
              <p className="txt-fs-5 clrgrey">Target</p>
            </div>
            <div className="col-6 text-end">
              <h5 className="fw-semibold clrgreen">
                {<span className="fw-semibold">{formattedTarget}</span>}
              </h5>
            </div>
            <hr className="mb-2 w-100" />
            <div className="col-6">
              <p className="txt-fs-5 clrgrey">
                {isGetClientGoal && isGetClientGoal?.yearLeftText}
              </p>
            </div>
            <div className="col-6 text-end">
              <h5 className="fw-semibold clrgreen">
                {isGetClientGoal ? (
                  `${isGetClientGoal?.yearsRemain?.toLocaleString("en-IN") || "0"
                  }`
                ) : (
                  <span
                    className="spinner-border text-success"
                    role="status"
                  ></span>
                )}
              </h5>
            </div>
            <hr className="mb-2 w-100" />
            <div className="col-6">
              <p className="txt-fs-5 clrgrey">Recommended SIP</p>
            </div>
            <div className="col-6 text-end">
              <h5 className="fw-semibold clrgreen">
                {isGetClientGoal ? (
                  `${formatRupees(isGetClientGoal?.monthlysaving) ||
                  "0"
                  }`
                ) : (
                  <span
                    className="spinner-border text-success"
                    role="status"
                  ></span>
                )}
              </h5>
            </div>
            <hr className="mb-2 w-100" />
            <div className="col-6">
              <p className="txt-fs-5 clrgrey">Suggested Portfolio</p>
            </div>
            <div className="col-6 text-end">
              <h5 className="fw-semibold clrgreen">
                {isGetClientGoal && isGetClientGoal?.portfolio}
              </h5>
            </div>
            <hr className="mb-2 w-100" />

            <div className="col-6">
              <p className="txt-fs-5 clrgrey">Target Return</p>
            </div>

            <div className="col-6">
              <div className="d-flex justify-content-end align-items-center gap-2">
                <h5 className="fw-semibold clrgreen mb-0">

                  {isGetClientGoal ? (
                    `${isGetClientGoal?.expectedReturn || "0"}%`
                  ) : (
                    <span
                      className="spinner-border text-success"
                      role="status"
                    ></span>
                  )}
                </h5>
              </div>
            </div>

            <hr className="mb-2 w-100" />

            <div className="col-6">
              <p className="txt-fs-5 clrgrey">

                {isGetClientGoal?.recActionPlanR4}
              </p>
            </div>

            <div className="col-6 text-end">
              <h5 className="fw-semibold clrgreen">
                {isRetirement && (
                  <Button
                    variant="outline-success"
                    size="sm"
                    className="rounded-circle fw-bold"
                    style={{
                      width: "30px",
                      height: "30px",
                      padding: 0,
                      lineHeight: "30px",
                      marginRight: "10px",
                    }}
                    onClick={() => {
                      
                      setshowRetirementTable(true);
                      socket.emit("show_retirement_projection", {
                      room: roomId,
                      show: true,
                    });
                    fetchRetirementInvestmentValues()
                    
                    }}
                  >
                    i
                  </Button>
                  
                )}
                {isFetchingRetirementInvestments && (
  <span
    className="spinner-border spinner-border-sm text-success ms-2"
    role="status"
    aria-label="Fetching retirement investments"
  />
)}
                {isGetClientGoal ? (
                  <>
                    {isGetClientGoal?.recActionPlanclass === "money" && "₹ "}
                    {isGetClientGoal?.recActionPlanVal?.toLocaleString() || "0"}
                    {isGetClientGoal?.recActionPlanclass === "percent" && "%"}
                    {isGetClientGoal?.recActionPlanclass === "time" && " Y"}
                  </>
                ) : (
                  <span
                    className="spinner-border text-success"
                    role="status"
                  ></span>
                )}
              </h5>
            </div>
          </div>

        </div>
       {isRetirement && (
  <Modal
    show={showRetirementTable}
    onHide={() => {
  setshowRetirementTable(false);

  socket.emit("show_retirement_projection", {
    room: roomId,
    show: false,
  });
}}
    size="xl"
    centered
    scrollable
    className="retirement-projection-modal"
  >
    <Modal.Body className="retirement-projection-body" 
    style={{ overflowY: "auto" }}
    onScroll={(e) => {
    socket.emit("retirement-scroll-update", {
      room: roomId,
      scrollTop: e.currentTarget.scrollTop,
      scrollLeft: e.currentTarget.scrollLeft,
    });
  }}>

      {/* HEADER */}
      <div className="projection-header">
        <div>
          <h1>Retirement Projection</h1>
          <p>
            View your projected retirement corpus and cash flow from
            accumulation to withdrawal.
          </p>
        </div>

        <div className="projection-header-actions">

  {/* FILTER BUTTON */}
  <button
    type="button"
    className="projection-filter-btn"
    onClick={() => setShowProjectionFilters((prev) => !prev)}
    title="Filters"
  >
    <FaFilter size={14} />
  </button>

  {/* CLOSE BUTTON */}
  <button
    type="button"
    className="projection-close-btn"
    onClick={() => {
  setshowRetirementTable(false);

  socket.emit("show_retirement_projection", {
    room: roomId,
    show: false,
  });
}}
    title="Close"
  >
    ×
  </button>

</div>
      </div>

      {/* SUMMARY CARDS */}
 
   {/* SUMMARY CARDS */}
<div className="rp-summary">

  {/* REQUIRED CORPUS */}
  <div className="rp-corpus">
    <div className="rp-corpus-head">
      <span>Required retirement corpus</span>
      <strong>
        {formatCompactRupees(
          activeRetirementResult?.required?.requiredTotalRetirementCorpus ?? 0
        )}
      </strong>
    </div>

    <div className="rp-corpus-track">
      <div
        className="rp-corpus-fill"
        style={{
          width: `${
            (activeRetirementResult?.required?.requiredTotalRetirementCorpus ?? 0) > 0
              ? Math.min(
                  100,
                  ((activeRetirementResult?.accumulation?.projectedRetirementCorpus ?? 0) /
                    activeRetirementResult.required.requiredTotalRetirementCorpus) * 100
                )
              : 0
          }%`,
        }}
      />
    </div>

    <div className="rp-corpus-foot">
      <span className="rp-projected">
        Projected:{" "}
        {formatCompactRupees(
          activeRetirementResult?.accumulation?.projectedRetirementCorpus ?? 0
        )}
      </span>
      <span className="rp-gap">
        Gap:{" "}
        {formatCompactRupees(Math.max(0, activeRetirementResult?.gap?.gap ?? 0))}
      </span>
    </div>
  </div>

  {/* 5 KPI CARDS - ONE ROW */}
  <div className="rp-kpi-row">

    <div className="rp-kpi">
      <div className="rp-kpi-top">
        <span className="rp-kpi-icon"><FaPersonWalkingWithCane /></span>
        <span className="rp-kpi-label">Retirement Age</span>
      </div>
      <strong className="rp-kpi-value">
        {activeRetirementResult?.inputs?.retirementAge ?? "—"}
      </strong>
    </div>

    <div className="rp-kpi">
      <div className="rp-kpi-top">
        <span className="rp-kpi-icon"><FaHeartPulse /></span>
        <span className="rp-kpi-label">Life Expectancy</span>
      </div>
      <strong className="rp-kpi-value">
        {activeRetirementResult?.inputs?.planIncomeUntilAge ?? "—"}
      </strong>
    </div>

    <div className="rp-kpi">
      <div className="rp-kpi-top">
        <span className="rp-kpi-icon"><FaArrowTrendUp /></span>
        <span className="rp-kpi-label">Expected Return</span>
      </div>
      <strong className="rp-kpi-value">
        {activeRetirementResult?.inputs?.accumulationReturn != null
          ? `${(activeRetirementResult.inputs.accumulationReturn * 100).toFixed(1)}%`
          : "—"}
      </strong>
    </div>

    <div className="rp-kpi">
      <div className="rp-kpi-top">
        <span className="rp-kpi-icon"><FaWallet /></span>
        <span className="rp-kpi-label">1st Month Expenses</span>
      </div>
      <strong className="rp-kpi-value">
        {formatCompactRupees(
          activeRetirementResult?.required?.firstMonthlyLifestyleExpense ?? 0
        )}
      </strong>
    </div>

    <div className={`rp-kpi ${corpusLastsUntil != null ? "rp-kpi-danger" : "rp-kpi-success"}`}>
      <div className="rp-kpi-top">
        <span className="rp-kpi-icon"><FaHourglassHalf /></span>
        <span className="rp-kpi-label">Corpus Lasts Until</span>
      </div>
      <strong className="rp-kpi-value">
        {corpusLastsUntil != null ? `Age ${corpusLastsUntil}` : "—"}
      </strong>
    </div>

  </div>
</div>

{/* PROJECTION VIEW SWITCH + SIP CONTROLS */}
<div className="retirement-projection-toolbar">
  <div className="projection-view-switch">
    <button
      type="button"
      className={`projection-view-btn ${
        projectionView === "year" ? "active" : ""
      }`}
      onClick={() => {
        setProjectionView("year");
        syncRetirementProjection({ projectionView: "year" });
      }}
    >
      <span>▤</span>
      Year by Year
    </button>

    <button
      type="button"
      className={`projection-view-btn ${
        projectionView === "month" ? "active" : ""
      }`}
      onClick={() => {
        setProjectionView("month");
        syncRetirementProjection({ projectionView: "month" });
      }}
    >
      <span>☷</span>
      Month by Month
    </button>
  </div>

  <div className="retirement-projection-toolbar-actions">
    <button
      type="button"
      className="retirement-sip-button"
      onClick={handleOpenSipInputs}
    >
      ⚡ Start SIP & Step-Up Impact
      {sipOverride !== "" || stepUpOverride !== ""
        ? ` (₹${Number(sipOverride || 0).toLocaleString("en-IN")} / ${
            stepUpOverride || 0
          }%)`
        : ""}
    </button>
  </div>
</div>

      {/* CENTERED POPUP MODAL IN MIDDLE OF TABLE SCREEN */}
      <Modal
        show={showSipInputs}
        onHide={() => setShowSipInputs(false)}
        centered
        size="md"
        style={{ zIndex: 1060 }}
      >
        <Modal.Header closeButton className="border-bottom pb-2">
          <Modal.Title className="fs-6 fw-bold text-success d-flex align-items-center gap-2">
            <span>⚡</span> Start SIP & Annual Step-Up Impact
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <p className="text-muted mb-4" style={{ fontSize: "13px" }}>
            Enter your starting monthly SIP and expected annual step-up rate to calculate its impact on your projected retirement corpus and shortfall/surplus in real time.
          </p>

          <div className="mb-3">
            <label className="form-label mb-1 text-dark fw-semibold" style={{ fontSize: "13px" }}>
              Current Monthly SIP (₹):
            </label>
            <div className="input-group input-group-lg">
              <span className="input-group-text bg-light text-muted fw-bold">₹</span>
              <input
                type="number"
                className="form-control fw-semibold"
                placeholder="e.g. 10000"
                value={sipOverride}
                onChange={(e) => {
                const value = e.target.value;
                setSipOverride(value);

                syncRetirementProjection({
                  sipOverride: value,
                });
              }}
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label mb-1 text-dark fw-semibold" style={{ fontSize: "13px" }}>
              Annual SIP Step-Up (%):
            </label>
            <div className="input-group input-group-lg">
              <input
                type="number"
                className="form-control fw-semibold"
                placeholder="e.g. 10"
                value={stepUpOverride}
                onChange={(e) => {
                const value = e.target.value;
                setStepUpOverride(value);

                syncRetirementProjection({
                  stepUpOverride: value,
                });
              }}
              />
              <span className="input-group-text bg-light text-muted fw-bold">%</span>
            </div>
          </div>
          
<div className="mb-3">
  <label className="form-label mb-1 text-dark fw-semibold">
    Current Investment Value (₹):
  </label>

  <div className="input-group input-group-lg">
    <span className="input-group-text bg-light text-muted fw-bold">
      ₹
    </span>

    <input
      type="number"
      className="form-control fw-semibold"
      placeholder="Current retirement investments"
      value={currentValueOverride}
      onChange={(e) => {
        const value = e.target.value;
        setCurrentValueOverride(value);

        syncRetirementProjection({
          currentValueOverride: value,
        });
      }}
    />
  </div>
</div>


          <div className="d-flex justify-content-between align-items-center pt-2 border-top">
            {(sipOverride !== "" || stepUpOverride !== "") ? (
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => {
                  setSipOverride("");
                  setStepUpOverride("");
                }}
              >
                Reset Inputs
              </Button>
            ) : <div></div>}

            <Button
              variant="success"
              className="fw-semibold px-4 text-white"
              onClick={() => setShowSipInputs(false)}
            >
              Apply & See Impact
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* FILTERS */}
      {/* FILTER PANEL */}
{showProjectionFilters && (
  <div className="projection-filter-panel">

    {/* SEARCH */}
    <div className="projection-filter-item projection-filter-search">
      <input
        type="text"
        className="projection-search"
        placeholder="Search age or stage..."
        value={projectionSearch}
        onChange={(e) => {
        const value = e.target.value;
        setProjectionSearch(value);

        syncRetirementProjection({
          projectionSearch: value,
        });
      }}
      />
    </div>

    {/* AGE */}
    <div className="projection-filter-item">
      <select
        className="projection-select"
        value={selectedAge}
        onChange={(e) => {
        const value = e.target.value;
        setSelectedAge(value);

        syncRetirementProjection({
          selectedAge: value,
        });
      }}
      >
        <option value="All Ages">All Ages</option>

        {ageRangeOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>

    {/* STAGE */}
    <div className="projection-filter-item">
      <select
        className="projection-select"
        value={selectedStage}
        onChange={(e) => {
  const value = e.target.value;
  setSelectedStage(value);

  syncRetirementProjection({
    selectedStage: value,
  });
}}
      >
        <option value="All Stages">All Stages</option>
        <option value="Accumulating">Accumulating</option>
        <option value="Withdrawing">Withdrawing</option>
      </select>
    </div>

    {/* HIGHLIGHT */}
    <div className="projection-filter-item">
      <select
        className="projection-select"
        value={selectedHighlight}
        onChange={(e) => {
  const value = e.target.value;
  setSelectedHighlight(value);

  syncRetirementProjection({
    selectedHighlight: value,
  });
}}
      >
        <option value="All Highlights">All Highlights</option>

        <option value="Ruin / Deficit Years (₹0)">
          ⚠️ Ruin / Deficit Years (₹0)
        </option>

        <option value="Peak Corpus Year">
          🏆 Peak Corpus Year
          {peakCorpusInfo ? ` (Age ${peakCorpusInfo.age})` : ""}
        </option>

        <option value="High Outflow Years">
          🔥 High Outflow Years (&gt;₹60L)
        </option>

        <option value="Contributions">
          Contributions
        </option>

        <option value="Expenses">
          Expenses
        </option>

        <option value="Income">
          Income
        </option>
      </select>
    </div>

    {/* SCENARIO */}
    <div className="projection-filter-item">
      <select
        className="projection-select"
        value={selectedScenario}
        onChange={(e) => {
  const value = e.target.value;
  setSelectedScenario(value);

  syncRetirementProjection({
    selectedScenario: value,
  });
}}
      >
        <option value="base">
          Base Case Return (
          {activeRetirementResult?.inputs?.accumulationReturn != null
            ? `${(
                Number(
                  activeRetirementResult.inputs.accumulationReturn
                ) * 100
              ).toFixed(0)}%`
            : "-"}
          )
        </option>

        <option value="lower_return">
          Lower Return (-2%)
        </option>

        <option value="higher_return">
          Higher Return (+2%)
        </option>

        <option value="higher_inflation">
          Higher Inflation (+1%)
        </option>

        <option value="longer_life">
          Longer Life (+5 Years)
        </option>

        <option value="combined_stress">
          Combined Stress
        </option>
      </select>
    </div>

    {/* RESET */}
    <button
      type="button"
      className="projection-filter-reset"
      onClick={() => {
        setProjectionSearch("");
        setSelectedAge("All Ages");
        setSelectedStage("All Stages");
        setSelectedHighlight("All Highlights");
        setSelectedScenario("base");
          syncRetirementProjection({
    projectionSearch: "",
    selectedAge: "All Ages",
    selectedStage: "All Stages",
    selectedHighlight: "All Highlights",
    selectedScenario: "base",
  });
      }}
    >
      Reset
    </button>

  </div>
)}

      {/* TABLE INFO + LEGEND */}
      <div className="projection-table-info">

        <span>
          Showing{" "}
          <strong>{filteredProjectionRows.length}</strong>{" "}
          of{" "}
          <strong>
            {projectionView === "year"
              ? retirementProjectionRows.length
              : retirementMonthlyRows.length}
          </strong>{" "}
          {projectionView === "year" ? "years" : "months"}
        </span>

        <div className="projection-legend">

          <span>
            <i className="legend-dot accumulating-dot"></i>
            Accumulating
          </span>

          <span>
            <i className="legend-dot withdrawing-dot"></i>
            Withdrawing
          </span>

        </div>

      </div>

      {/* NEW TABLE */}
      <div
  className="projection-table-wrapper"
  onScroll={(e) => {
    socket.emit("retirement-table-scroll-update", {
      room: roomId,
      scrollTop: e.currentTarget.scrollTop,
    });
  }}
>

        <table className="projection-table">

          <thead>
            <tr>
              <th>AGE</th>
              <th>STAGE</th>
              <th>CONTRIBUTION</th>
              <th>EXPENSE</th>
              <th>INCOME</th>
              <th>ENDING BALANCE</th>
            </tr>
          </thead>

          <tbody>

            {filteredProjectionRows.length > 0 ? (
              filteredProjectionRows.map((row, index) => {
                return (
                  <tr
                    key={`${row.stage}-${projectionView}-${row.age}-${row.monthIndex || index}`}
                  >
                    <td className="age-cell">
                      {projectionView === "month"
                        ? row.ageMonthLabel
                        : row.age}
                    </td>

                    <td>
                      <span
                        className={`stage-badge ${
                          row.stage === "Accumulating"
                            ? "stage-accumulating"
                            : "stage-withdrawing"
                        }`}
                      >
                        <span className="stage-dot"></span>
                        {row.stage}
                      </span>
                    </td>

                    <td
                      className={
                        Number(row.contribution) > 0
                          ? "positive-value"
                          : ""
                      }
                    >
                      {Number(row.contribution) > 0
                        ? `+${formatCompactRupees(row.contribution)}`
                        : "—"}
                    </td>

                    <td
                      className={
                        Number(row.expense) > 0
                          ? "negative-value"
                          : ""
                      }
                    >
                      {Number(row.expense) > 0
                        ? `−${formatCompactRupees(row.expense)}`
                        : "—"}
                    </td>

                    <td
                      className={
                        Number(row.income) > 0
                          ? "positive-value"
                          : ""
                      }
                    >
                      {Number(row.income) > 0
                        ? `+${formatCompactRupees(row.income)}`
                        : "—"}
                    </td>

                    <td className="balance-cell">
                      {formatCompactRupees(
                        Number(row.endingBalance) || 0
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan="6"
                  className="empty-projection-table"
                >
                  No retirement projection data available.
                </td>
              </tr>
            )}

          </tbody>

        </table>

      </div>

    </Modal.Body>
  </Modal>
)}
        <div
          className="col-md-7 ps-4 position-relative h-100 overflow-auto"
          style={{ minHeight: "200px", maxHeight: "400px" }}
        >
          <Card>
            <Card.Header className=" p-0">
              <div className="d-md-flex d-none align-items-center justify-content-end ps-4">
                {/* <div className="d-flex gap-2">
                  <FaPlus
                    onClick={() => {
                      setIsLoading(true);
                      setNumberOfLabels((prev) => prev + 10);
                    }}
                    className="cursor-pointer"
                  />

                  <FaMinus
                    onClick={() => {
                      if (numberOfLabels > 10) {
                        setIsLoading(true);
                        setNumberOfLabels((prev) => prev - 10);
                      }
                    }}
                    className={`cursor-pointer ${
                      numberOfLabels === 10
                        ? "opacity-50 pointer-events-none"
                        : ""
                    }`}
                  />
                </div> */}

                <div>
                  <Card.Body>
                    <p className="impact-value mb-0">Target</p>
                    <div className="d-flex align-items-center">
                      <Card.Title className="fs-4">
                        {" "}
                        <span className="fw-semibold">{formattedTarget}</span>
                      </Card.Title>
                      <FaArrowTrendUp className="ms-2 text-success trend-icon" />
                    </div>
                  </Card.Body>
                </div>
              </div>
              <div className="d-md-none">
                <div>
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-center">
                      {/* Left side: Target Info */}
                      <div>
                        <p className="impact-value mb-0">Target</p>
                        <div className="d-flex align-items-center">
                          <Card.Title className="fs-4 mb-0">
                            <span className="fw-semibold">
                              {formattedTarget}
                            </span>
                          </Card.Title>
                          <FaArrowTrendUp className="ms-2 text-success trend-icon" />
                        </div>
                      </div>

                      {/* Right side: Plus/Minus Buttons */}
                      {/* <div className="d-flex gap-2">
                        <FaPlus
                          onClick={() => {
                            setIsLoading(true);
                            setNumberOfLabels((prev) => prev + 10);
                          }}
                          className="cursor-pointer"
                        />

                        <FaMinus
                          onClick={() => {
                            if (numberOfLabels > 10) {
                              setIsLoading(true);
                              setNumberOfLabels((prev) => prev - 10);
                            }
                          }}
                          className={`cursor-pointer ${
                            numberOfLabels === 10
                              ? "opacity-50 pointer-events-none"
                              : ""
                          }`}
                        />
                      </div> */}
                    </div>
                  </Card.Body>
                </div>
              </div>
            </Card.Header>
            <Card.Body className="position-relative">
              {/* <div className="w-100 overflow-auto">
              <div style={{ minWidth: '800px' }}> */}
              <ReactApexChart
                key={numberOfLabels}
                options={chartOptions}
                series={chartData?.series || []}
                type="area"
                height={262}
              />
              {/* </div>
            </div> */}
            </Card.Body>
          </Card>

          {/* Goal Tracker Details Positioned on Left */}
          {goal && mappedFunds && mappedFunds.length > 0 && (
            <div
              className="goal-details position-absolute d-none d-md-block fw-normal"
              style={{
                minHeight: "160px",
                maxHeight: "200px",
                maxWidth: "240px",
                // overflowY: "auto",
                top: "5px",
                fontSize: "12px",
              }}
            >
              <p className="d-flex refer justify-content-between align-align-items-center ">
                <span>Projected Achievement:</span>{" "}
                <span className="fw-semibold">
                  {projectedAchievement.toFixed(2)}%
                </span>
              </p>
              <p className="d-flex refer justify-content-between align-align-items-center ">
                <span>Running Sip:</span>
                <span className="fw-semibold">{formattedRunninSip}</span>
              </p>

              <p className="d-flex refer justify-content-between align-align-items-center ">
                <span>Accumulated Amount:</span>{" "}
                <span className="fw-semibold">
                  <span className="fw-semibold">{formattedAccumulated}</span>
                </span>
              </p>

              <p
                className="d-flex refer justify-content-between align-align-items-center "
                style={{
                  color: projectedShortfall < 0 ? "green" : "black",
                }}
              >
                <span>Projected Shortfall:</span>{" "}
                <span className="fw-semibold">
                  {formatAmount(projectedShortfall)}
                </span>
              </p>

              <p
                className="d-flex refer justify-content-between align-align-items-center "
                style={{ color: goal.sipDeficit < 0 ? "green" : "black" }}
              >
                <span>SIP Deficit:</span>
                <span className="fw-semibold">{formattedSipDeficit}</span>
              </p>

              <p className="d-flex refer justify-content-between align-align-items-center ">
                <span>Timeline:</span>
                <span className="fw-semibold"> {goal?.timeline} Years</span>
              </p>
              <p className="d-flex refer justify-content-between align-align-items-center ">
                <span>Years Left:</span>
                <span className="fw-semibold">
                  {/* {Number(goal?.targetYear) - new Date().getFullYear()} Years */}
                  {/* {Number(goal?.yearsRemain)} Years */}

                  {isGetClientGoal?.yearLeftText === 'Goal Timeline (Years)' ?
                    Number(isGetClientGoal?.goalYear) - new Date().getFullYear() : isGetClientGoal?.yearsRemain?.toLocaleString("en-IN") || "0"

                  } Years
                </span>
              </p>
            </div>
          )}
        </div>

        {goal && mappedFunds && mappedFunds.length > 0 && (
          <div className="mt-4 d-block d-md-none fs-16 fw-normal ">
            <p className="d-flex justify-content-between align-align-items-center ">
              <span>Projected Achievement:</span>{" "}
              <span className="fw-semibold">
                {projectedAchievement.toFixed(2)}%
              </span>
            </p>
            <p className="d-flex justify-content-between align-align-items-center ">
              <span>Running Sip:</span>
              <span className="fw-semibold">{formattedRunninSip}</span>
            </p>

            <p className="d-flex justify-content-between align-align-items-center ">
              <span>Accumulated Amount:</span>{" "}
              <span className="fw-semibold">
                {formatAmount(goal?.accumulatedAmount)}
              </span>
            </p>

            <p
              className="d-flex justify-content-between align-align-items-center "
              style={{
                color: projectedShortfall < 0 ? "green" : "black",
              }}
            >
              <span>Projected Shortfall:</span>{" "}
              <span className="fw-semibold">
                {" "}
                {formatAmount(projectedShortfall)}
              </span>
              {/* {Math.abs(goal.projectedShortfall).toLocaleString()} */}
            </p>

            <p
              className="d-flex justify-content-between align-align-items-center "
              style={{ color: goal.sipDeficit < 0 ? "green" : "black" }}
            >
              <span>SIP Deficit:</span>
              <span className="fw-semibold"> {formattedSipDeficit}</span>
            </p>

            <p className="d-flex justify-content-between align-align-items-center ">
              <span>Timeline:</span>
              <span className="fw-semibold"> {goal?.timeline} Years</span>
            </p>
            <p className="d-flex justify-content-between align-align-items-center ">
              <span>Years Left:</span>
              <span className="fw-semibold">
                {/* {Number(goal?.targetYear) - new Date().getFullYear()} Years */}
                {/* {Number(goal?.yearsRemain)} Years */}
                {isGetClientGoal?.yearLeftText === 'Goal Timeline (Years)' ?
                  Number(isGetClientGoal?.goalYear) - new Date().getFullYear() : isGetClientGoal?.yearsRemain?.toLocaleString("en-IN") || "0"
                } Years
              </span>
            </p>
          </div>
        )}
      </div>
    </>
  );
}
